<template>
    <div class="custom-loader">
        <button v-if="success || failed" class="close-button" type="button" @click="closeAction">
            <i class="fal fa-times"/>
        </button>

        <ui-load-indicator
            v-if="loading && !success && !failed"
            bg-color="#e7e9f4"
            color="#69D296"
            :h="60"
            :stroke="8"
        />

        <div v-if="success && !failed" class="loader success">
            <i class="fal fa-check icon"/>
        </div>

        <div v-if="failed && !success" class="loader failed">
            <i class="fal fa-times icon"/>
        </div>

        <div class="info">
            <div v-if="message" class="message">{{ message }}</div>
            <div v-if="description" class="description">{{ description }}</div>
            <slot name="complement" />
        </div>

        <slot v-if="success && !failed" name="success"/>
        <slot v-if="failed && !success" name="failed"/>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

	export default {
		name: 'ui-loader-message',

		components: {
			uiLoadIndicator,
		},

		props: {
			loading: {
				type: Boolean,
				default: false,
			},

			success: {
				type: Boolean,
				default: false,
			},

			failed: {
				type: Boolean,
				default: false,
			},

			message: {
				type: String,
				default: '',
			},

			description: {
				type: String,
				default: '',
			},

			closeAction: {
				type: Function,
				required: true,
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
